const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    meta: {requiresAuth: true},
    children: [
      { path: '', component: () => import('pages/IndexPage.vue') },
      {
        path: '/account',
        meta: { area:'account' },
        component: () => import('pages/AccountPage'),
        children: [
          {
            path: 'plans',
            meta: { label: 'plans', context: 'account'},
            component: () => import('pages/AccountPlans')
          },
          {
            path: 'dashboard',
            meta: { label: 'dashboard', context: 'account'},
            component: () => import('pages/AccountDashboard')
          },
          {
            path: 'billing',
            name: 'billing',
            meta: { label: 'billing', context: 'account'},
            props: route => ({ intent: route.query.intent }),
            component: () => import('pages/Billing')
          }
        ]
      },
      { path: '/workspaces/:workspaceId',
        redirect: to => {
          return { path: `/workspaces/${to.params.workspaceId}/data/dashboard` }
        },
        children: [
        {
          path: 'addons',
          name: 'addons',
          meta: { area:'addons' },
          props: route => ({ intent: route.query.intent }),
          component: () => import('pages/WorkspaceAddons.vue')
        },
        { path: 'data', meta: { area:'data' }, component: () => import('pages/WorkspacePage.vue'), children: [
            { path: 'inbox/:formId?',
              meta: { label: 'inbox', context: 'submissions' },
              component: () => import('pages/FormInbox.vue'),
              props: route => ({ folder: 'inbox', formId: route.params.formId })
            },
            { path: 'spam/:formId?',
              meta: { label: 'spam', context: 'submissions' },
              component: () => import('pages/FormInbox.vue'),
              props: route => ({ folder: 'spam', formId: route.params.formId })
            },
            { path: 'trash/:formId?',
              meta: { label: 'trash', context: 'submissions' },
              component: () => import('pages/FormInbox.vue'),
              props: route => ({ folder: 'trash', formId: route.params.formId })
            },
            { path: 'dashboard',
              meta: { label: 'dashboard', context: 'dashboard' },
              component: () => import('pages/WorkspaceDashboard.vue')},
          ] },
        { path: 'forms/:formId', meta: { context:'form' }, children: [
            { path: 'edit', meta: { area:'edit' }, component: () => import('pages/FormEdit.vue'), children: [
                { path: 'studio',
                  name: 'studio',
                  meta: { label: 'studio' },
                  component: () => import('pages/StudioWrapper.vue')},
                { path: 'settings',
                  meta: { label: 'settings' },
                  component: () => import('pages/FormSettings.vue')},
                { path: 'notifications',
                  meta: { label: 'notifications' },
                  component: () => import('pages/FormNotifications.vue')},
                { path: 'auto-response',
                  meta: { label: 'auto response' },
                  component: () => import('pages/FormAutoResponse.vue')},
                { path: 'spam-filter',
                  meta: { label: 'spam filter' },
                  component: () => import('pages/FormSpamFilter.vue')},
                { path: 'file-upload',
                  name: 'fileUpload',
                  meta: { label: 'file upload' },
                  component: () => import('pages/FormFileUpload.vue')},
                { path: 'no-bounce',
                  meta: { label: 'no bounce email protection' },
                  component: () => import('pages/FormNoBounce.vue')},
                { path: 'integrations',
                  meta: { label: 'integrations' },
                  component: () => import('pages/FormIntegrations.vue')},
                { path: 'connect',
                  meta: { label: 'connect' },
                  component: () => import('pages/FormDeploy.vue')},
                { path: 'build',
                  name: 'build',
                  meta: { label: 'design, share & embed' },
                  component: () => import('pages/BuildAndEmbed.vue')},
              ] }
          ] },
        { path: 'edit', meta: { context:'workspace', area:'edit' }, component: () => import('pages/WorkspacePage.vue'), children: [
            { path: 'team',
              meta: { label: 'team' },
              component: () => import('pages/Team.vue')},
            { path: 'settings',
              meta: { label: 'settings' },
              component: () => import('pages/WorkspaceSettings.vue')},
            { path: 'forms',
              name: 'forms',
              meta: { label: 'forms' },
              component: () => import('pages/Forms.vue') },
          ]}
        ]
      }
    ]
  },
  {
    path: '/auth',
    component: () => import('layouts/AuthLayout.vue'),
    children: [
      { path: '/auth/login', component: () => import('pages/Auth.vue') },
      { path: '/auth/signup', component: () => import('pages/Auth.vue'),
        props: route => ({mode: 'register', inv: route.query.inv})
      },
      {
        path: '/auth/acceptInvite',
        component: () => import('pages/AcceptInvite.vue')
      },
      {
        path: '/auth/assignAppsumoLicense',
        component: () => import('pages/AssignAppsumoLicense.vue')
      },
      {
        path: '/auth/plans',
        component: () => import('pages/AccountPlans.vue'),
        props: {mode: 'standAlone'}
      },
      {
        path: '/auth/reset-password',
        component: () => import('pages/ResetPassword.vue'),
        props: (route) => {
          return {
            oobCode: route.query.oobCode,
            apiKey: route.query.apiKey,
            continueUrl: route.query.continueUrl
          }
        }
      },
    ]
  },
  {
    path: '/oauth',
    component: () => import('layouts/AuthLayout.vue'),
    children: [
      {
        path: 'authorize',
        component: () => import('pages/OAuth/Authorize.vue')
      },
      {
        path: 'success',
        component: () => import('pages/OAuth/Success.vue')
      },
    ]
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue')
  }
]

export default routes
